import React from 'react';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { colors } from '../../Themes/Colors';
import { celularLabel } from '../../Utils/FnUtils';
import styles from './styles.module.scss';

interface WhatsappNumberProps {
  number: string;
  textValue?: string;
}

function WhatsappNumber({ number, textValue }: WhatsappNumberProps) {
  function handleOpenWhatsapp(
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) {
    event.stopPropagation();

    window.open(`https://wa.me/55${number}`);
  }

  return (
    <a
      role="button"
      tabIndex={0}
      onClick={handleOpenWhatsapp}
      className={styles.container}
    >
      <FontAwesomeIcon
        icon={faWhatsapp}
        color={colors.brandGreen}
        className={styles.icon}
      />
      {textValue || celularLabel(number)}
    </a>
  );
}

export default WhatsappNumber;
